// Shared error presentation constants for chat messages.
//
// Extracted from Message.tsx so the full-error bubble and the "answer stopped
// early" notice (StreamErrorNotice) speak the same language for a given error
// code — a user must not get a different hint depending on whether any content
// happened to be committed before the failure.

/** User-friendly hints per error code. */
export const ERROR_HINTS: Record<string, string> = {
  STREAM_TIMEOUT: "Try a shorter or more specific question.",
  TIMEOUT: "Try a shorter or more specific question.",
  DATASOURCE_NOT_FOUND: "Connect a data source to this agent in the settings.",
  DATASOURCE_NOT_CONFIGURED: "The data source needs to be configured first.",
  CONNECTION_FAILED: "Contact support if this problem persists.",
  NO_MAPPINGS_FOUND: "This question doesn't match the available data. Try something else.",
  INCOMPLETE_STREAM: "Something went wrong while loading.",
  BACKEND_UNAVAILABLE: "The server is not reachable. Please try again later.",
  QUERY_FAILED: "Check the data source connection and credentials.",
  SETUP_FAILED: "Check whether a data source is connected to the agent.",
  AGENT_NOT_RESOLVED: "Try asking again from the chart's Analyze panel. Contact support if this keeps happening.",
  AUTH_EXPIRED: "Log in again to continue.",
};

/** Error codes that represent "data not available" rather than a system error. */
export const INFO_ERROR_CODES = new Set([
  "IR_LOW_CONFIDENCE",
  "MAPPING_FAILED",
  "NO_MAPPINGS_FOUND",
  "EMPTY_RESULT",
]);
